export default __webpack_public_path__ + "static/media/dessert06.d5cb2ced.png";